export const host = process.env.REACT_APP_BACKEND_URL;
export const registerRoute = `${host}/api/auth/register`;
export const loginRoute = `${host}/api/auth/login`;
export const setAvatarRoute = `${host}/api/auth/setAvatar`;
export const allUsersRoute = `${host}/api/auth/allusers`;
export const sendMessageRoute = `${host}/api/messages/addmsg`;
export const getAllMessagesRoute = `${host}/api/messages/getmsg`;
export const conversationsRoute = `${host}/api/messages/conversations`;
export const newChatUsersRoute = `${host}/api/auth/newchatusers`;